import axiosInstance from "../components/api/axiosInstance";

function normalizeCustomerAccountList(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.data)) return raw.data;
  if (Array.isArray(raw.Data)) return raw.Data;
  if (Array.isArray(raw.customer_accounts)) return raw.customer_accounts;
  if (Array.isArray(raw.Customer_Accounts)) return raw.Customer_Accounts;
  if (Array.isArray(raw.items)) return raw.items;
  return [];
}

export async function fetchCustomerAccounts() {
  // Backend currently supports client-id scoped fetch (`/fico/client-accounts/:id`).
  // Keep this helper returning empty to avoid noisy 404/405 calls from unsupported list endpoints.
  return [];
}

export async function fetchCustomerAccountsByCustomerId(customerId) {
  if (customerId == null || customerId === "") return [];
  const res = await axiosInstance.get(`/fico/client-accounts/${customerId}`);
  return normalizeCustomerAccountList(res.data);
}

export async function fetchCustomerAccountById(accountId) {
  if (accountId == null || accountId === "") {
    throw new Error("Customer account id is required.");
  }
  const res = await axiosInstance.get(`/fico/client-account/${accountId}`);
  const raw = res?.data;
  return raw?.data ?? raw?.Data ?? raw?.customer_account ?? raw?.Customer_Account ?? raw;
}

export async function createCustomerAccount(payload) {
  const res = await axiosInstance.post("/fico/client-account", payload);
  return res.data?.data ?? res.data;
}

export async function updateCustomerAccount(accountId, payload) {
  if (accountId == null || accountId === "") {
    throw new Error("Customer account id is required.");
  }
  const res = await axiosInstance.put(`/fico/update-client-account/${accountId}`, payload);
  return res.data?.data ?? res.data;
}

export async function deleteCustomerAccount(accountId) {
  if (accountId == null || accountId === "") {
    throw new Error("Customer account id is required.");
  }
  const res = await axiosInstance.delete(`/fico/delete-client-account/${accountId}`);
  return res.data?.data ?? res.data;
}
